document.addEventListener("DOMContentLoaded", function () {
  const toggleButtons = document.querySelectorAll(".toggle-password");

  toggleButtons.forEach(function (toggleButton) {
    const wrapper = toggleButton.closest(".password-toggle-wrapper");
    const input = wrapper.querySelector(
      "input[type='password'], input[type='text']"
    );

    toggleButton.addEventListener("click", function () {
      const isVisible = wrapper.classList.contains("password-visible");
      wrapper.classList.toggle("password-visible");

      input.type = isVisible ? "password" : "text";
    });
  });
});
